module.exports = __webpack_public_path__ + "static/media/wishBg.7a855db4.png";